import { FormInit } from "../../../../../../../_ovlclient/src/library/forms/formapi"
import { T } from "../../../../../../../_ovlclient/src/global/globals"
import type { SYSAction } from "../../../../../../../_ovlclient/src"
import type { SYSFormField } from "../../../../../../../_ovlclient/src/library/forms/fieldapi"

const HookScreenNavigateIn: SYSAction = async (_, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  let fields: { [key: string]: SYSFormField } = {
    msg: {
      value: state.app.features.DATFeedback.message,
      ui: { labelTranslationKey: "DATDocumentDataFeedbackPleaseEnterText" },
    },
  }
  FormInit("DATFeedback", fields, {
    formId: state.app.features.DATFeedback.type,
    initialFocusFieldKey: "msg",
  })
}

let hooks = { HookScreenNavigateIn }
export let DATFeedback = { hooks }
